import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "display"]

  connect() {
    // Initialize display with formatted value if present
    if (this.inputTarget.value) {
      this.updateDisplay()
    }
  }

  format(event) {
    this.updateDisplay()
  }

  updateDisplay() {
    const value = this.inputTarget.value.replace(/[^0-9]/g, "")

    if (value === "") {
      this.displayTarget.value = ""
      return
    }

    // Format with commas
    const formatted = this.formatCurrency(parseInt(value))
    this.displayTarget.value = formatted
  }

  // Update hidden input when user types in display field
  updateInput(event) {
    const value = this.displayTarget.value.replace(/[^0-9]/g, "")
    this.inputTarget.value = value
  }

  formatCurrency(value) {
    return value.toLocaleString("en-CA")
  }
}
